<h4 *ngIf="additionaLanguageRows?.length > 0">EU official languages</h4>
<div id="eu_languages" *ngFor="let row of languageRows" class="row">
    <div *ngFor="let language of row" class="col-md-6 mb-2">
        <button euiButton euiBlockButton
            [euiSecondary]="language.code !== config.selectedLanguage.code"
            [euiPrimary]="language.code === config.selectedLanguage.code"
            (click)="selectLanguage(language)">
            {{ language.label }} ({{ language.code }})
        </button>
    </div>
</div>
<ng-container *ngIf="additionaLanguageRows?.length > 0">
    <br>
    <h4>Non-EU Languages</h4>
    <div id="extra_languages" *ngFor="let row of additionaLanguageRows" class="row">
        <div *ngFor="let language of row" class="col-md-6 mb-2">
            <button euiButton euiBlockButton
                    [euiSecondary]="language.code !== config.selectedLanguage.code"
                    [euiPrimary]="language.code === config.selectedLanguage.code"
                    (click)="selectLanguage(language)">
                {{ language.label }} ({{ language.code }})
            </button>
        </div>
    </div>
</ng-container>
